"use client";
import { cn } from "@/lib/tailwind";
import React, { useEffect } from "react";

interface IProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const TopSheet: React.FC<IProps> = ({ open, onClose, children }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className={`fixed inset-0 z-50 ${open ? "pointer-events-auto" : "pointer-events-none"}`}>
      <div
        className={cn(
          `absolute left-0 top-0 h-screen w-full overflow-y-auto bg-white shadow-lg transition-transform duration-300`,
        )}
        style={{
          transform: open ? "translateY(0px)" : "translateY(-100%)",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default TopSheet;
